import { Check as IconCheck, Warning as IconWarning } from "@mui/icons-material";

import { EmptyFieldworkerPlaceholder } from "./EmptyFieldworkerPlaceholder";

type FieldworkerAssignmentListStatusIconProps = {
    fieldworkersStillNeeded: number;
};

export function FieldworkerAssignmentListStatusIcon({
    fieldworkersStillNeeded,
}: FieldworkerAssignmentListStatusIconProps) {
    if (fieldworkersStillNeeded > 0) {
        return <EmptyFieldworkerPlaceholder size="small" />;
    }
    if (fieldworkersStillNeeded === 0) {
        return <IconCheck sx={theme => ({ color: theme.palette.grey[500] })} />;
    }
    if (fieldworkersStillNeeded < 0) {
        return <IconWarning sx={theme => ({ color: theme.palette.grey[500] })} />;
    }
}
